import Tool from '../../common/tool';
var HeaderMain = /** @class */ (function () {
    function HeaderMain() {
        this.headerDom = document.getElementById('header');
        this.init();
    }
    HeaderMain.prototype.init = function () {
        this.headerEvent();
    };
    HeaderMain.prototype.headerEvent = function () {
        var that = this;
        // header菜单打开和关闭-点击
        var headerNavIcon = Tool.$_select(that.headerDom, '.daetool-header-nav-icon');
        var headerSearchIcon = Tool.$_select(that.headerDom, '.daetool-header-search-icon');
        var headerCategoryList = Tool.$_select(that.headerDom, '.daetool-header-category-list');
        var headerCloseIcon = Tool.$_select(that.headerDom, '.daetool-header-close-icon');
        headerCloseIcon.addEventListener('click', function () {
            Tool.toggleShowAndHide({
                hideTarget: [headerCloseIcon, headerCategoryList],
                showTarget: [headerNavIcon, headerSearchIcon]
            });
        });
        headerNavIcon.addEventListener('click', function () {
            Tool.toggleShowAndHide({
                hideTarget: [headerNavIcon, headerSearchIcon],
                showTarget: [headerCloseIcon, headerCategoryList]
            });
        });
        // header产品分类打开和关闭-点击-一级
        var headerCategoryListLiveItem = Tool.$_selectAll(that.headerDom, '.daetool-header-category-list-content-box-live1-item');
        var headerCategoryListLiveItemTitle = Tool.$_selectAll(that.headerDom, '.daetool-header-category-list-content-box-live1-item-title');
        headerCategoryListLiveItemTitle.forEach(function (item) {
            item.addEventListener('click', function () {
                // 切换时不展开其他分类
                var hasActive = item.parentNode.classList.contains('live1-item');
                if (hasActive) {
                    item.parentNode.classList.remove('live1-item');
                }
                else {
                    headerCategoryListLiveItem.forEach(function (hItem) { return hItem.classList.remove('live1-item'); });
                    item.parentNode.classList.add('live1-item');
                }
            });
        });
        // header 产品分类展开/收起：一级分类下直接展示全部产品
        var headerCategoryListItemTitle = Tool.$_selectAll(that.headerDom, '.daetool-header-category-list-item.list-item-live2 .daetool-header-category-list-item-title');
        headerCategoryListItemTitle.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.stopPropagation();
                item.parentElement.classList.toggle('live2-item');
            });
        });
        // // 全部产品-点击
        // const allProductDom = Tool.$_select(that.headerDom, '.daetool-header-category-bottom-btn');
        // allProductDom.addEventListener('click', () => {
        // 	window.location.href = '/product'
        // })
    };
    return HeaderMain;
}());
export default HeaderMain;
